<template>
  <section class="product-main">
    <!-- 主要内容 -->
    <div class="product-main-content">
      <div class="main-content"
           v-for="(item,index) in list"
           :key="index">
        <div class="main-content-description"
             :class="{'description-left':index%2==0,'description-right':index%2!=0}">
          <span>
            {{lang=='zh_CN'?item.title_cn:item.title_en}}
          </span>
          <span>
            {{lang=='zh_CN'?item.description_cn:item.description_en}}
          </span>
        </div>
        <div class="main-content-img"
             :class="{'img-right':index%2==0}">
          <template v-for="(img,idx) in item.images">
            <div :key="idx"
                 :class="{'div-right':index%2==0}">
              <span>
                <img :src="img.url">
              </span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <!-- 想要了解更多 -->
    <div class="product-more-content">
      <div class="know-more-title">
        <span>{{$t('official.product.moreContent.title')}}</span>
      </div>
      <div class="know-more-content">
        <span>
          {{this.$t('official.product.moreContent.mainOne')}}
        </span>
        <span>
          {{this.$t('official.product.moreContent.mainTwo')}}
        </span>
        <span>
          {{this.$t('official.product.moreContent.mainThree')}}
        </span>
        <span>
          {{this.$t('official.product.moreContent.mainFour')}}
        </span>
      </div>
      <div class="know-more-btn"
           @click="openView('details')">
        <span>
          {{this.$t('official.product.moreContent.btnText')}}
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import Api from 'official/api/product.api'
import { mapState } from 'vuex'
export default {
  name: 'LitaiProduct',
  data() {
    return {
      api: Api,
      list: [],
    }
  },
  computed: {
    ...mapState({
      lang: state => state.core.lang//当前语言
    })
  },
  created() {
    this.findAll()
  },
  methods: {
    findAll() {
      this.api.find().then(res => {
        let datas = res.data.result
        datas.forEach(element => {
          let obj = {
            title_cn: '',
            title_en: '',
            description_cn: '',
            description_en: '',
            images: []
          }
          if (element.product) {
            obj.title_cn = element.product.title_cn
            obj.title_en = element.product.title_en
            obj.description_cn = element.product.description_cn
            obj.description_en = element.product.description_en
          }
          if (element.images) {
            obj.images = element.images
          }
          this.list.push(obj)
        })
      })
    },
    openView(type) {
      this.$emit('returnType', type)
      this.$router.push(`/${type}`)
    }
  }
}
</script>

